import { StyleSheet } from 'aphrodite';
import { white } from '../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		boxSizing: 'border-box',
		display: 'flex',
		height: '100%',
		paddingLeft: 0,
		paddingRight: 16,
		background: white,
		flex: 1,
	},
	notFound: {
		display: 'block',
		marginTop: 30,
		width: '100%',
	},
	splitDetail: {
		borderLeft: '1px solid #ccc',
		flex: '1 0 0',
		overflowX: `hidden`,
		height: `100%`,
		container: 'contactActivity / inline-size',
	},
	splitMaster: {
		flex: '0 0 392px',
		overflowY: 'auto',
		background: white,
	},
	backButton: {
		width: '100%',
	},
	backButtonIcon: {
		transform: 'rotate(180deg)',
	},
});
